import type { AdminOrgUsageEntry } from '../types/api'
import { apiClient } from './client'

export interface OrgEntry {
  id: number
  slug: string
  name: string
  isActive: boolean
  workspaceDomain: string | null
  createdAt: string
}

export interface CreateOrgAdminInput {
  email: string
  username: string
  password?: string
}

export interface CreateOrgInput {
  slug: string
  name: string
  workspaceDomain?: string
  admin?: CreateOrgAdminInput
}

export interface CreatedOrgAdmin {
  id: number
  email: string
  username: string
  role: string
  isActive: boolean
  // Deprecated, always false / 'any'. There is no per-admin provider: the
  // admin is allowlisted for any provider and chooses at sign-in.
  signInWithGoogle: boolean
  oauthProvider: 'any'
}

export interface CreatedOrg {
  org: OrgEntry
  adminUser: CreatedOrgAdmin | null
  mcpKey: { token: string; tokenPrefix: string } | null
}

export async function listOrganizations(): Promise<OrgEntry[]> {
  return apiClient.get<OrgEntry[]>('/admin/organizations')
}

export async function createOrganization(input: CreateOrgInput): Promise<CreatedOrg> {
  return apiClient.post<CreatedOrg>('/admin/organizations', input)
}

export async function setOrganizationActive(id: number, isActive: boolean): Promise<OrgEntry> {
  return apiClient.patch<OrgEntry>(`/admin/organizations/${id}`, { isActive })
}

export async function setOrganizationStorageLimit(
  id: number,
  storageLimitBytes: number | null
): Promise<OrgEntry> {
  return apiClient.patch<OrgEntry>(`/admin/organizations/${id}`, { storageLimitBytes })
}

export async function getAdminOrgUsage(): Promise<AdminOrgUsageEntry[]> {
  return apiClient.get<AdminOrgUsageEntry[]>('/admin/orgs/usage')
}
